export default __webpack_public_path__ + "images/own_goal.0b32a3.png";